import script from "./PointOfSaleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PointOfSaleItem.vue?vue&type=script&setup=true&lang=js"

import "./PointOfSaleItem.vue?vue&type=style&index=0&id=761e8300&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761e8300"]])

export default __exports__